module.exports = __webpack_public_path__ + "img/image2.71c12b16.gif";